export class Banner {
	// 初期化処理
	static init() {
		
		$('.banner__slide').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 765,
					settings: {
						centerMode: true,
						slidesToShow: 1
					}
				},
			]
		});
	}
}
